import { useQuery } from "@tanstack/react-query";
import { useMemo } from "react";
import { useSearchParams } from "react-router-dom";
import { getStationAllowedDomainMessage } from "use-smart-locks-shared";
import { getCampingStationBySlug } from "../../../shared/api/nest-api";
import { getAuthRedirectContext } from "../client/login-redirect";

export const getAuthStationRestrictionMessage = (
  allowedEmailDomains: string[],
): string => getStationAllowedDomainMessage(allowedEmailDomains);

export const useAuthPageContext = (): {
  nextPath: string;
  stationSlug?: string;
  stationName?: string;
  allowedEmailDomains: string[];
  isLoadingStationContext: boolean;
  stationContextErrorMessage?: string;
} => {
  const [searchParams] = useSearchParams();
  const { nextPath, stationSlug } = useMemo(
    () => getAuthRedirectContext(searchParams),
    [searchParams],
  );

  const stationQuery = useQuery({
    queryKey: ["auth", "station-context", stationSlug],
    queryFn: async () => {
      if (!stationSlug) {
        throw new Error("stationSlug is required");
      }

      return getCampingStationBySlug(stationSlug);
    },
    enabled: !!stationSlug,
    staleTime: 60_000,
  });

  return {
    nextPath,
    stationSlug,
    stationName: stationQuery.data?.name,
    allowedEmailDomains: stationQuery.data?.allowedEmailDomains ?? [],
    isLoadingStationContext: !!stationSlug && stationQuery.isPending,
    stationContextErrorMessage:
      stationSlug && stationQuery.isError
        ? "Stationskontext konnte nicht geladen werden. Bitte versuchen Sie es erneut."
        : undefined,
  };
};
